import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const byViews = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);
  const byRating = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-bar-chart-line text-lg text-primary-500"></i>
              </div>
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">人气排行</h2>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              {byViews.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className={`flex items-center gap-4 px-4 py-3 hover:bg-background-100 transition-colors duration-200 ${
                    index < byViews.length - 1 ? 'border-b border-background-200/50' : ''
                  }`}
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold whitespace-nowrap ${
                    index < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0">
                    <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-foreground-950 line-clamp-1">{comic.title}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{(comic.views / 10000).toFixed(0)}万阅读</span>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-star-line text-lg text-accent-500"></i>
              </div>
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">评分排行</h2>
            </div>
            <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              {byRating.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className={`flex items-center gap-4 px-4 py-3 hover:bg-background-100 transition-colors duration-200 ${
                    index < byRating.length - 1 ? 'border-b border-background-200/50' : ''
                  }`}
                >
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold whitespace-nowrap ${
                    index < 3
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0">
                    <img src={comic.coverImage} alt={comic.title} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-bold text-foreground-950 line-clamp-1">{comic.title}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  </div>
                  <span className="flex items-center gap-1 text-xs font-bold text-accent-600 whitespace-nowrap">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500"></i>
                    </div>
                    {comic.rating}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}